import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {

  const helpLinks = [
    { name: "Shipping & Returns", path: "/shipping-returns" },
    { name: "Size Guide", path: "/size-guide" },
    { name: "FAQ", path: "/faq" },
    { name: "Contact Us", path: "/contact" },
    { name: "Privacy Policy", path: "/privacy-policy" }
  ];

  return (
    <footer className="bg-lux-primary text-white">
      <div className="px-6 md:px-12 lg:px-20 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">

          {/* Brand */}
          <div className="md:col-span-1">
            <span className="font-display text-2xl tracking-[0.2em] font-medium transition-all hover:tracking-[0.25em] duration-500 cursor-default">
              AURÉNE
            </span>
            <p className="mt-6 text-[11px] font-sans font-light text-white/50 leading-relaxed tracking-wider max-w-[240px]">
              Elevated essentials for the discerning wardrobe. Crafted with
              intention, designed for longevity.
            </p>
          </div>

          {/* Shop */}
          <div>
            <p className="label-sm text-white/40 mb-4">Shop</p>
            {["Men", "Women"].map((cat) => (
              <Link
                key={cat}
                to={`/shop?category=${cat.toLowerCase()}`}
                className="block text-xs font-sans font-light text-white/60 hover:text-lux-gold transition-colors py-1 tracking-wider"
              >
                {cat}
              </Link>
            ))}
          </div>

          {/* Help */}
          <div>
            <p className="label-sm text-white/40 mb-4">Help</p>
            {helpLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className="block text-xs font-sans font-light text-white/60 hover:text-lux-gold transition-colors py-1 tracking-wider"
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Follow + Newsletter */}
          <div>
            <p className="label-sm text-white/40 mb-4">Follow</p>

            <div className="flex gap-4 mt-2">
              {["Instagram", "Pinterest", "Twitter"].map((social) => (
                <a
                  key={social}
                  href="#"
                  className="text-xs font-sans text-white/60 hover:text-lux-gold transition-colors tracking-wider"
                >
                  {social}
                </a>
              ))}
            </div>

            <div className="mt-8">
              <p className="label-sm text-white/40 mb-3">Newsletter</p>

              <div className="flex">
                <input
                  placeholder="Your email"
                  className="flex-1 bg-white/10 border-b border-white/20 text-white text-xs py-2 px-3 focus:outline-none placeholder:text-white/30 font-sans"
                />

                <button className="bg-lux-gold text-white text-xs px-4 py-2 tracking-wider hover:bg-white hover:text-lux-primary transition-colors">
                  →
                </button>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs font-sans font-light text-white/40 tracking-widest">
            © 2024 AURÉNE. All rights reserved.
          </p>

          <p className="text-xs font-sans font-light text-white/30 tracking-wider">
            Crafted with precision.
          </p>
        </div>
      </div>
    </footer>
  );
}